import type { BeforeRequestHook } from 'ky';
import type { HookGetterArgs } from '../../types';

export const getMobileAuthHeaders =
  ({ fetchArgs }: HookGetterArgs): BeforeRequestHook =>
  () => {
    // do nothing, placeholder function for React web
  };
